export default {"src":"/_next/static/media/bank-linepay-square.50646d2e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};